const FORM_BASE =
  "https://docs.google.com/forms/d/e/1FAIpQLSdbFeZEiSZnI6P4pl6Y7O_NRzr6huBff0jKgaPXfsR6HJRF3g/viewform";

const ENTRY_IDS = {
  too_slow: "1709287261",
  calming: "1335097922",
  standard: "1490791832",
  exciting: "2060768350",
  too_fast: "1663683854",
};

export function buildPrefillUrl(answers, { field = "bpm" } = {}) {
  const params = new URLSearchParams();

  for (const [key, entryId] of Object.entries(ENTRY_IDS)) {
    const val = answers?.[key]?.[field];
    if (val !== undefined && val !== null && val !== "") {
      params.set(`entry.${entryId}`, String(val));
    }
  }

  return `${FORM_BASE}?${params.toString()}`;
}
